import api from "@/lib/api";

export default {
    urlGetAll: `/api/v1/financial/payable-receivable/get-all`,
    urlDelete: `/api/v1/finance/payable-receivable/delete`,
    urlMarkAsPaid: `/api/v1/financial/payable-receivable/mark-as-paid`,
    urlUnmarkAsPaid: `/api/v1/financial/payable-receivable/unmark-as-paid`,
    urlMarkInstallmentsAsPaid: `/api/v1/financial/payable-receivable/mark-installments-as-paid`,
    urlOpenInstallments: `/api/v1/financial/payable-receivable/open-installments`,

    urlPartialPaymentGetAll: `/api/v1/financial/partial-payment/get-all`,
    urlPartialPaymentCreate: `/api/v1/financial/partial-payment/create`,
    urlPartialPaymentUpdate: `/api/v1/financial/partial-payment/update`,
    urlPartialPaymentDelete: `/api/v1/financial/partial-payment/delete`,

    async list(filter = {}) {
        const response = await api.get(this.urlGetAll, { params: filter });
        return response.data.content;
    },

    async delete(ids) {
        return api.delete(this.urlDelete, { data: { ids } });
    },

    async getOpenInstallments(id) {
        const response = await api.get(this.urlOpenInstallments, { params: { id } });
        return response.data;
    },

    async getAllPartialPayment(payableReceivableId) {
        const response = await api.get(this.urlPartialPaymentGetAll, { params: { payableReceivableId } });

        return response.data;
    },

    async updatePartialPayment(model) {
        const response = await api.post(this.urlPartialPaymentUpdate, model);
        return response.data;
    },

    async createPartialPayment(model) {
        const response = await api.post(this.urlPartialPaymentCreate, model);
        return response.data;
    },

    async deletePartialPaymentById(id) {
        const response = await api.post(this.urlPartialPaymentDelete, { id });
        return response.data;
    },
};
